import { roleBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const roleDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.ROLE,
    name: 'Role',
    selectionListIds: ['role_k7', 'role_k150', 'role_k1500', 'role_k15000'],
    selections: [],
    branches: roleBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_ROLE },
});

export const roleDefinition: FilterDefinition<TreeFilter> =
  roleDescriptor.definition;
